import { TUserProfile, USER_ROLE } from '@/types/user-profile'
import Service, { getCallApiFunction } from '../service'

export type ParamsType = {
  role?: string
  memberInfoId?: string
  followeeType?: USER_ROLE
  followerType?: USER_ROLE
}
export type ResponseType = {
  isSuccess: boolean
  memberInfo: TUserProfile[]
}
class FetchFollowersApi extends Service {
  constructor({ memberInfoId, ...rest }: ParamsType) {
    super()
    this.config = {
      url: '/v1/livemall/member/follower',
      method: 'GET',
      params: {
        ...rest,
        id: memberInfoId,
      },
    }
  }
}
export const fetchFollowers = async (params: ParamsType): Promise<ResponseType> => getCallApiFunction(new FetchFollowersApi(params))
